<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="24">
        <el-date-picker
          :appendToBody="false"
          :clearable="false"
          format="yyyy-MM"
          value-format="yyyy-MM"
          @change="handlerDateChange"
          class="day-item"
          type="month"
          unlink-panels
          v-model="params.dtMonth"
        ></el-date-picker>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col
        :lg="6"
        :md="12"
        :sm="12"
        :xl="6"
        v-for="(item, index) in cardOptions"
        :key="index"
        class="card-item mt-18"
      >
        <dataCard :item="item" v-loading="loading.cardLoading" :active="0">
          <div v-if="index === 1" slot="icon" class="icon-slot">
            <div class="slot-line">
              <span>{{ $t('customer::profits::新客数') }}</span>
              <span>{{ newCustomerNum }}</span>
            </div>
            <div class="slot-line">
              <span>{{ $t('customer::profits::复购客数') }}</span>
              <span>{{ reorderCustomerNum }}</span>
            </div>
          </div>
        </dataCard>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :md="24" :lg="12" class="mt-18">
        <div :style="`height: ${reportHeight};`" class="avg-container" v-loading="loading.cardReportLoading">
          <cardIconReport :cardData="cardReportOptions"></cardIconReport>
          <div class="avg-wrap">
            <div class="avg-content">
              <span>{{ $t('customer::profits::lostCustomer', { lossCustomerNum: lossCustomerNum }) }}</span>
              <a @click="toCustomer">{{ $t('customer::profits::checkCustomer') }}</a>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :md="24" :lg="12">
        <reportCard
          :config="customerAttr"
          v-loading="loading.customerAttrLoading"
          :style="`height: ${reportHeight};`"
        ></reportCard>
      </el-col>
      <el-col :md="24" :lg="12">
        <reportCard
          :config="newCustomer"
          v-loading="loading.newCustomerLoading"
          :style="`height: ${reportHeight};`"
        ></reportCard>
      </el-col>
      <el-col :md="24" :lg="12">
        <reportCard
          :config="customerReorder"
          v-loading="loading.customerReorderLoading"
          :style="`height: ${reportHeight};`"
        ></reportCard>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import moment from 'moment'
import setConfig from './setConfig'
import dataCard from '@/components/data-analysis/slotCard'
import reportCard from '@/components/data-analysis/report'
import cardIconReport from '@/components/data-analysis/cardIconReport/cardIconReport.vue'
import {
  getCustomerOverview,
  getCustomerAvgOverview,
  getCustomerAttribute,
  getCustomerNewTrend,
  getCustomerReorder,
} from '@/server/etl'
import { getReports, queryData } from '@/server/dashboard'
export default {
  mixins: [setConfig],
  components: { dataCard, reportCard, cardIconReport },
  data() {
    return {
      reportHeight: '400px',
      cardOptions: {}, // 四个数据
      cardReportOptions: {},
      params: {
        dtMonth: moment().format('YYYY-MM'),
        orgUnitId: this.$store.state.user.merchantId,
      },
      customerAttr: {},
      newCustomer: {},
      customerReorder: {},
      loading: {
        cardLoading: false,
        cardReportLoading: false,
        customerAttrLoading: false,
        newCustomerLoading: false,
        customerReorderLoading: false,
      },
      lossCustomerNum: 0,
      newCustomerNum: 0,
      reorderCustomerNum: 0,
      reports: [12985],
      boardData: [],
    }
  },
  mounted() {
    this.cardOptions = this.setCardOptions()
    this.cardReportOptions = this.setCardReportOptions()
    this.init()
  },
  methods: {
    toCustomer() {
      this.$router.push('/customer/list')
    },
    handlerDateChange() {
      this.cardOptions = this.setCardOptions()
      this.cardReportOptions = this.setCardReportOptions()
      this.customerAttr = {}
      this.newCustomer = {}
      this.customerReorder = {}
      this.getAllData()
    },
    init() {
      this.getCustomerOverview()
      this.getCustomerAvgOverview()
      this.getCustomerAttribute()
      this.getCustomerNewTrend()
      this.setReportQueryInit(1, () => this.getCustomerReorder())
    },
    getAllData() {
      this.getCustomerOverview()
      this.getCustomerAvgOverview()
      this.getCustomerAttribute()
      this.getCustomerNewTrend()
      this.getCustomerReorder()
    },
    async getCustomerOverview() {
      this.loading.cardLoading = true
      const { data } = await getCustomerOverview({ ...this.params })
      this.loading.cardLoading = false
      if (data.code === this.$code) {
        this.cardOptions = this.setCardOptions(data.data.datas)
      }
    },
    async getCustomerAvgOverview() {
      this.loading.cardReportLoading = true
      const { data } = await getCustomerAvgOverview({ ...this.params })
      this.loading.cardReportLoading = false
      if (data.code === this.$code) {
        this.cardReportOptions = this.setCardReportOptions(data.data.datas)
      }
    },
    async getCustomerAttribute() {
      this.loading.customerAttrLoading = true
      const { data } = await getCustomerAttribute({ ...this.params })
      this.loading.customerAttrLoading = false
      if (data.code === this.$code) {
        this.customerAttr = this.setCustomerAttribute(data.data.datas)
      }
    },
    async getCustomerNewTrend() {
      this.loading.newCustomerLoading = true
      const { data } = await getCustomerNewTrend({ ...this.params })
      this.loading.newCustomerLoading = false
      if (data.code === this.$code) {
        this.newCustomer = this.setCustomerNewTrend(data.data.datas)
      }
    },
    async getCustomerReorder() {
      const reportId = 12985
      this.customerReorder = this.setCustomerReorder()
      if (!this.reports.includes(reportId)) {
        return false
      }
      this.loading.customerReorderLoading = true
      this.setReportQuery(1, reportId, data => {
        if (data.status === 200) {
          this.customerReorder = this.setCustomerReorder(data.result.funnel.series[0].data)
        }
        this.loading.customerReorderLoading = false
      })
    },
    // 报表数据构建Init
    async setReportQueryInit(boardID, callback) {
      if (!(this.boardData && this.boardData.length)) {
        const res = await getReports({
          boardID,
        })
        if (!res.result[0]) {
          return false
        }
        this.boardData = res.result
        this.reports = this.reports.filter(item => res.result.map(report => report.reportID).includes(item))
      }

      callback()
    },
    // 报表数据构建
    async setReportQuery(boardID, reportId, callback) {
      if (!(this.boardData && this.boardData.length)) {
        const res = await getReports({
          boardID,
        })
        if (!res.result[0]) {
          return false
        }
        this.boardData = res.result
      }
      const data = await queryData(
        this.setParamsReport(
          this.boardData.find(item => item.reportID == reportId),
          {
            ...this.params,
          }
        )
      )
      callback(data)
    },
    // 构建report请求
    setParamsReport(result, params = {}) {
      // 配置params 别名
      const alias = []
      // 是否有时间匹配
      if (params.dtMonth) {
        alias.push('dt_month')
      }
      const dimensions = result.requestDimensions // 堆积过滤条件concat 条件conditions
      const filters = result.otherParams.filter // 过滤条件，用alias取对应的uuid
      const pageSize = result.otherParams.pageSize
      let conditions = result.requestConditions
      const dirlls = result.drillDimensions
      const measures = result.requestMeasures

      // 判断alias 是否匹配到filters值
      alias.forEach(alia => {
        if (filters.some(item => alia == item.alias)) {
          const conditionItem = filters.find(item => alia == item.alias) || {}

          if (conditionItem.columnType == 'DATE') {
            conditions = conditions.filter(item => item.uuid != conditionItem.uuid)
            conditions.push({
              queryType: 'LARGEEQUAL',
              requestValue: [params.dtMonth],
              uuid: conditionItem.uuid,
            })
            conditions.push({
              queryType: 'LESSEQUAL',
              requestValue: [params.dtMonth],
              uuid: conditionItem.uuid,
            })
          } else {
            conditions = conditions.filter(item => item.uuid != conditionItem.uuid)
            const filterItem = filters.find(item => alia == item.alias)
            let queryType = ''
            if (filterItem) {
              queryType = filterItem.filterGroup.filterType.split('-')[1].toUpperCase()
            }
            conditions.push({
              queryType,
              requestValue: [String(params.dtMonth)],
              uuid: conditionItem.uuid,
            })
          }
        }
      })

      return {
        check: false,
        conditions,
        modelID: result.modelID,
        offSet: 1,
        pageSize,
        reportID: result.reportID,
        dimensions,
        measures,
        dirlls,
      }
    },
  },
}
</script>

<style scoped lang="scss">
.avg-container {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .avg-wrap {
    flex: 1;
    background: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    .avg-content {
      background: #ecf2ff;
      display: flex;
      justify-content: space-between;
      padding: 20px 40px;
      width: 80%;
    }
  }
}
.icon-slot {
  min-width: 120px;
  border-radius: 4px;
  .slot-line {
    padding: 16px;
    background: #fafbfc;
    border-bottom: 1px solid #d8d8d8;
    display: flex;
    justify-content: space-between;
    &:last-child {
      border-bottom: none;
    }
  }
}
</style>
